import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
import fonts from '../utils/fonts';

class ImagenBg extends React.Component {
  render() {
    const Bloque = styled.div`
      padding: ${this.props.full ? '0 1em 0 1em' : 0};
    `;

    const Padre = styled.div`
      width: 100%;
      height: 500px;
      overflow: hidden;
    `;

    const Hijo = styled.div`
		transition: all .5s;
    width: 100%;
		height: 100%;
		background-color: ${colors.black}; /* fallback color */
		background-image: url('./img/${this.props.width > 500 ? 'alta' : 'baja'}/${this.props.name}.jpg');
		background-position: center;
		background-size: cover;
		&:hover {
			transform: scale(1.2);
		}
		`;

    const Pie = styled.p`
      color: ${colors.oscuro};
      font-family: ${fonts.sans}, sans-serif;
      font-weight: 300;
      letter-spacing: 0.1rem;
      margin: 0;
      padding: 0 0 0.5em 0;
    `;

    const Firma = styled.p`
      margin-top: 1rem;
      color: ${colors.oscuro};
      font-family: ${fonts.sans}, sans-serif;
      font-weight: 300;
      letter-spacing: 0.1rem;
      text-align: right;
      text-transform: uppercase;
      font-size: 1.2rem;
      margin: 0;
      padding: 0;
    `;

    return (
      <div>
        <Padre>
          <Hijo />
        </Padre>
        <Bloque>
          <Firma>{this.props.firma}</Firma>
          <Pie>{this.props.pie}</Pie>
        </Bloque>
      </div>
    );
  }
}

export default ImagenBg;



// WEBPACK FOOTER //
// ./src/components/ImagenBg.js